// extracted by mini-css-extract-plugin
export default {"container":"SeriesButton_container__84Pzy"};